import React, { useLayoutEffect, useState } from "react";
import { isObject } from "lodash";
import { getTokenImage, isWebGWFile } from "../../helpers/fileHelper";

export default function TokenImage(props) {
  const { render, src, href, enableOpenTabOnPress, ...imgProps } = props;
  const [dataSrc, setDataSrc] = useState(
    Array.isArray(src) ? [] : typeof src === "string" ? undefined : src
  );

  if (render !== undefined && typeof render !== "function") {
    throw new Error("TokenImage: render is not a function");
  }

  useLayoutEffect(() => {
    if (Array.isArray(src)) {
      Promise.all(src.map((u) => (isWebGWFile(u) ? getTokenImage(u) : u))).then(
        (srcs) => setDataSrc(srcs)
      );
    } else if (typeof src === "string" || (isObject(src) && "url" in src)) {
      if (isWebGWFile(src)) {
        getTokenImage(src).then((tokenSrc) => setDataSrc(tokenSrc));
      } else {
        setDataSrc(src);
      }
    } else {
      setDataSrc(src);
    }
  }, [JSON.stringify(src)]);

  let imageContent = null;
  if (render && typeof render === "function") imageContent = render(dataSrc);
  else
    imageContent = (
      <img
        src={Array.isArray(dataSrc) ? dataSrc[0] : dataSrc}
        {...imgProps}
      ></img>
    );

  if (enableOpenTabOnPress) {
    let _href = null;
    if (typeof href === "function") _href = href(dataSrc);
    else _href = href || (Array.isArray(dataSrc) ? dataSrc[0] : dataSrc);
    return (
      <a href={_href} target="_blank" rel="noopener noreferrer">
        {imageContent}
      </a>
    );
  }

  return imageContent;
}
